module.exports = __webpack_public_path__ + "img/selected4-min.889f5b63.png";